module.exports = __webpack_public_path__ + "img/zz4.03799ac9.png";